// DetailTransactionModal.js
import React from 'react';
import { Modal, ModalHeader, ModalBody,Row,Col } from 'reactstrap';
import '../utils/detail.css';
const DetailTransactionModal = ({ isOpen, toggle, transaction }) => {
  if (!transaction) return null;
  return (
    <Modal isOpen={isOpen} toggle={toggle} contentClassName="custom-modal-size">
        <ModalHeader toggle={toggle} className="custom-modal-header">
        <span className="custom-texte"> Détails de la transaction</span></ModalHeader>
        <div className="centrer"> 
            <span>ID  : </span> <span style={{color:"#00000063",fontWeight:"500",fontSize:"13px",FontFamily:'Poppins'}}>{transaction?.transactionReference}</span>
            <div className="">
                    {(() => {
                    let label = "Inconnu";
                    let icon = "";
                    const style = {
                    backgroundColor: "#FFEFD5",
                    color: "#000",
                    padding: "1px 6px",
                    borderRadius: "100px",
                    fontWeight: 400,
                    fontSize: "13px",
                    fontStyle: 'Medium' };
                    if (transaction.status === 'SUCCESS') {
                    label = "Réussie";
                    icon = "✓";
                    style.backgroundColor = "#EBFFEA"; 
                    style.color = "#349C32";          
                    } else if (transaction.status === 'REJECTED') {
                      label = "Echouée";
                    icon = "✓"; 
                    style.backgroundColor = "#FFF0F0"; 
                    style.color = "#D41C1C";         
                    }
                    return <span>Statut : <span style={style}>
                      {icon} {label}</span></span>
                    })()}  
                  </div>
         </div>
        <ModalBody className='centrerBody'>
        <Row >
         <Col className="attribut" md={6}>Business</Col>
         <Col  className="titleInfo"md={6}>{transaction.developerAccountName || "pas de nom"}</Col>
        </Row>
        <hr style={{color:'#E8E8E8',border: '1px solid #E8E8E8',marginTop:'10px'}}></hr>
        <Row >
         <Col className="attribut" md={6}>Nom marchand</Col>
         <Col  className="titleInfo"md={6}>{transaction.merchantAccountName || "pas de nom"}</Col>
        </Row>
        <hr style={{color:'#E8E8E8',border: '1px solid #E8E8E8',marginTop:'10px'}}></hr>
       <Row >
         <Col className="attribut" md={6}>Date de la transaction</Col>
         <Col className="titleInfo" md={6}>
          {new Date(transaction.createdAt).toLocaleString("fr-FR")}
        </Col>
        </Row>
         <hr style={{color:'#E8E8E8',border: '1px solid #E8E8E8',marginTop:'10px'}}></hr>
       
        <Row >
         <Col className="attribut" md={6}>Opérateur</Col>
         <Col  className="titleInfo"md={6}>{transaction.paymentMethodName}</Col>
        </Row>
        <hr style={{color:'#E8E8E8',border: '1px solid #E8E8E8',marginTop:'10px'}}></hr>
         <Row >
         <Col className="attribut" md={6}>N° Téléphone</Col>
         <Col  className="titleInfo"md={6}>{transaction.clientNumber}</Col>
        </Row>
        <hr style={{color:'#E8E8E8',border: '1px solid #E8E8E8',marginTop:'10px'}}></hr>
        <Row >
         <Col className="attribut" md={6}>Montant</Col>
         <Col  className="titleInfo"md={6}>{transaction.amount} {transaction.currency}</Col>
        </Row>
        <hr style={{color:'#E8E8E8',border: '1px solid #E8E8E8'}}></hr>
        <Row >
         <Col className="attribut" md={6}>Pays</Col>
         <Col  className="titleInfo"md={6}>{transaction.countryCode}</Col>
        </Row>
        
      </ModalBody>
    </Modal>
  );
};

export default DetailTransactionModal;
